import { selectFeatureFlags } from 'core/userContext/selectors';
import { useSelector } from 'react-redux';
import {
  COLLECTION_REFERENCES,
  LOOKUP_REFERENCES,
  PRODUCT_RECOMMENDATIONS,
} from '../../../constants';
import { useBillingQueryContext } from '../../../contexts';
import { LoadingCard } from '../LoadingCard';
import { MetricRow } from '../MetricRow';
import { MetricTile } from '../MetricTile';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import { Container, Header, MainContent, Marquee, RowsWrapper, Title } from '../styled';
import { CATALOG_CARD_IDS, CATALOG_CARD_TEXT } from './constants';

const {
  cardTitle,
  catalogCollectionDescription,
  catalogCollectionName,
  catalogLookupDescription,
  catalogLookupName,
  productRecommendationDescription,
  productRecommendationName,
  projectBreakdownUrl,
} = CATALOG_CARD_TEXT;

export const CatalogCard = () => {
  const { ProductRecommendations } = useSelector(selectFeatureFlags);
  const { pickOrgValue, isLoading } = useBillingQueryContext();

  const collectionReferencesValue = pickOrgValue(COLLECTION_REFERENCES);
  const lookupReferencesValue = pickOrgValue(LOOKUP_REFERENCES);
  const productRecommendationsValue = pickOrgValue(PRODUCT_RECOMMENDATIONS);

  const recValue = ProductRecommendations ? productRecommendationsValue : 0;
  const totalValue = collectionReferencesValue + lookupReferencesValue + recValue;

  return isLoading ? (
    <LoadingCard />
  ) : (
    <Container data-test={CATALOG_CARD_IDS.cardId}>
      <Header>
        <Title>{cardTitle}</Title>
        <div>
          <ProjectBreakdownLink to={projectBreakdownUrl} />
        </div>
      </Header>
      <Marquee>
        <MetricTile
          label="Catalog references"
          tooltip="Sum of CatalogLookup, CatalogCollection, and ProductRecommendation."
          value={totalValue}
        />
      </Marquee>
      <MainContent>
        <RowsWrapper>
          <MetricRow
            label={catalogLookupName}
            tooltip={catalogLookupDescription}
            value={lookupReferencesValue}
          />
          <MetricRow
            label={catalogCollectionName}
            tooltip={catalogCollectionDescription}
            value={collectionReferencesValue}
          />
          {ProductRecommendations && (
            <MetricRow
              label={productRecommendationName}
              tooltip={productRecommendationDescription}
              value={productRecommendationsValue}
            />
          )}
        </RowsWrapper>
      </MainContent>
    </Container>
  );
};
